import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  warningButton: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    },
  },
}))

export default styles
